import { MaxLengthValidatorDirective } from '../../shared/directives/max-length-validator.directive';
import { NumericOnlyDirective } from '../../shared/directives/numeric-only.directive';
import { BusinessClock } from '../../core/time/business-clock.service';
import { clockView } from '../../core/time/business-time';
import { JstDate } from '../../core/time/business-time';
import { Component, NgZone, OnInit, inject } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PageTitleService } from '../../core/services/page-title.service';
import { NotificationService } from '../../core/services/notification.service';
import { MemberApiService } from '../../core/services/member-api.service';
import { StudioService } from '../../core/services/studio.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-notification-payment',
    imports: [MaxLengthValidatorDirective, NumericOnlyDirective, FormsModule, RouterLink],
    templateUrl: './notification-payment.component.html'
})
export class NotificationPaymentComponent implements OnInit {
  private readonly businessClock = inject(BusinessClock);
  private readonly clockContext = clockView(true);

  private pageTitle = inject(PageTitleService);
  private notificationService = inject(NotificationService);
  private memberApi = inject(MemberApiService);
  private studioService = inject(StudioService);
  private router = inject(Router);
  private toastr = inject(ToastrService);
  private ngZone = inject(NgZone);

  member: any = {};
  products: any[] = [];
  btPaymentEnabledMypage = 0;
  btPostLoading = false;
  isButtonDisable = false;
  shopId = environment.shopId;

  select: any = { singlePayment: { paymentMethod: null }, getGmo: { expireMonthAt: '', expireYearAt: '' } };
  cc_expire_months: number[] = Array.from({ length: 12 }, (_, i) => i + 1);
  cc_expire_years: string[] = Array.from({ length: 11 }, (_, i) => String(new JstDate().getFullYear() + i).slice(-2));

  nextPaymentDateCc: Date;
  nextPaymentDateBt: Date;

  constructor() {
    const now = new JstDate();
    const modify = now.getDate() > 9 ? 2 : 1;
    this.nextPaymentDateCc = new JstDate(now.getFullYear(), now.getMonth() + modify, 1);
    this.nextPaymentDateBt = new JstDate(now.getFullYear(), now.getMonth() + modify - 1, 1);
  }

  async ngOnInit(): Promise<void> {
    this.pageTitle.set('fa s-icon-edit', '申請');
    this.member = await this.memberApi.getOne('self');
    const studio = await this.studioService.list(this.member?.studio?.id);
    this.btPaymentEnabledMypage = Number(studio?.btPaymentEnabledMypage || 0);
    const products = await this.studioService.getProduct(this.member?.studio?.id);
    this.products = Array.isArray(products) ? products.filter((product: any) => product.status === 0) : [];
  }

  async openBtRegistration(): Promise<void> {
    if (this.btPostLoading) return;
    const targetName = `bt-register-${Date.now()}`;
    const popup = window.open('', targetName);
    if (!popup) {
      this.toastr.warning('口座登録ページを開けませんでした。ポップアップブロックを解除してください。', '', { timeOut: 5000 });
      return;
    }
    this.btPostLoading = true;
    try {
      const result = await this.memberApi.createBtPostValues(this.member.id, this.select.singlePayment?.paymentMethod);
      this.btPostLoading = false;
      if (!Array.isArray(result) || !result.length) {
        popup.close();
        this.toastr.warning('口座登録情報の取得に失敗しました。', '', { timeOut: 5000 });
        return;
      }
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = environment.btPostUrl;
      form.target = targetName;
      form.acceptCharset = 'Windows-31J';
      result.forEach((item: any) => {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = item.key; input.value = item.value;
        form.appendChild(input);
      });
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
      popup.focus();
    } catch {
      this.btPostLoading = false;
      popup.close();
      this.toastr.warning('口座登録情報の取得に失敗しました。', '', { timeOut: 5000 });
    }
  }

  async save(): Promise<void> {
    if (this.isButtonDisable || this.select.singlePayment?.paymentMethod == null || this.select.singlePayment.paymentMethod === '') return;
    if (!await this.businessClock.confirm(this.clockContext, () => this.refreshClockDates())) return;
    const pm = Number(this.select.singlePayment?.paymentMethod);
    if (pm === 0 && this.btPaymentEnabledMypage === 1) {
      this.toastr.warning('口座振替は「オンライン口座登録」ボタンから手続きしてください。', '', { timeOut: 5000 });
      return;
    }
    this.isButtonDisable = true;
    const now = new JstDate();
    const modify = now.getDate() > 9 ? 2 : 1;
    const json: any = {
      studioId: this.member.studio.id,
      memberId: this.member.id,
      requestMonth: `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`,
      requestType: 6,
      beforePaymentMethod: this.member.payment?.paymentMethod,
      afterPaymentMethod: pm,
    };

    if (pm === 1 && this.select.getGmo?.HolderName) {
      if (!/^[a-zA-Z0-9\x20,.\-\/]+$/.test(this.select.getGmo.HolderName)) {
        this.toastr.warning('名義には半角英字および記号を入力してください', '', { timeOut: 5000 });
        this.isButtonDisable = false;
        return;
      }
      const gmo = this.select.getGmo;
      const expire = String(gmo.expireYearAt) + ('0' + String(gmo.expireMonthAt)).slice(-2);
      (window as any).Multipayment.init(this.shopId);
      (window as any).Multipayment.getToken({
        holdername: String(gmo.HolderName),
        cardno: String(gmo.CardNo),
        expire,
        securitycode: String(gmo.security),
      }, (res: any) => {
        void this.ngZone.run(async () => {
          if (!await this.businessClock.confirm(this.clockContext, () => this.refreshClockDates())) { this.isButtonDisable = false; return; }
          if (res.resultCode === '000' && res.tokenObject?.token) {
            this.select.singlePayment.memberId = this.member.id;
            this.select.singlePayment.memberCode = this.member.memberCode;
            this.select.singlePayment.gmo = { username: gmo.HolderName, token: res.tokenObject.token };
            const data = await this.memberApi.createPayment(this.member.id, this.select.singlePayment);
            if (!data?.message) {
              json.status = 2;
              json.startDate = new JstDate(now.getFullYear(), now.getMonth() + modify, 1);
              await this.notificationService.upsert(json);
              this.toastr.success('支払方法を更新しました', '', { timeOut: 5000 });
            } else {
              this.toastr.warning(data.message, '', { timeOut: 5000 });
              this.isButtonDisable = false;
              return;
            }
          } else {
            this.toastr.warning('クレジットカード情報を再度入力してください', '', { timeOut: 5000 });
            this.isButtonDisable = false;
            return;
          }
          await this.router.navigate(['/notification']);
        });
      });
    } else {
      json.startDate = new JstDate(now.getFullYear(), now.getMonth() + modify, 0);
      const v = await this.notificationService.upsert(json);
      if (!v) {
        this.toastr.error('諸届を申請できませんでした。', '', { timeOut: 5000 });
      } else {
        this.toastr.success('お手続きについてご案内いたします。店舗へお越し下さい。', '', { timeOut: 5000 });
      }
      this.router.navigate(['/notification']);
    }
  }

  formatDate(d: Date, format: string): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return format.replace('yyyy', String(y)).replace('MM', m).replace('dd', day);
  }
  private refreshClockDates(): void {
    const now = new JstDate();
    const modify = now.getDate() > 9 ? 2 : 1;
    this.nextPaymentDateCc = new JstDate(now.getFullYear(), now.getMonth() + modify, 1);
    this.nextPaymentDateBt = new JstDate(now.getFullYear(), now.getMonth() + modify - 1, 1);
  }

}
